import * as React from 'react'

export type FunctionalHighlightCardProps = {
	icon: React.ReactNode
	text: React.ReactNode
	className?: string
}

export const FunctionalHighlightCard: React.FC<
	FunctionalHighlightCardProps
> = ({ icon, text, className }) => {
	return (
		<div
			className={`flex items-center gap-[24px] rounded-xl border border-gray-200 bg-white p-[24px] ${className}`}
		>
			<div className="flex-shrink-0 text-teal-600">{icon}</div>
			<p className="leading-snug text-blue-800 md:text-xl">{text}</p>
		</div>
	)
}
